import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { startHealthCheck } from "@/lib/healthCheck";
import { isHandledApiError } from "@/lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// ---------------------------------------------------------------------------
// Gestione MIRATA delle Promise non gestite.
// Non è una soppressione globale: interveniamo SOLO per gli AxiosError già
// gestiti dall'interceptor in `lib/api.js` (dove il toast italiano è già stato
// mostrato). In quel caso preveniamo l'overlay dev-server per evitare che
// l'utente veda il traceback tecnico, ma il dettaglio resta in console.
// Tutti gli altri errori NON vengono soppressi: gli errori di programmazione
// devono restare visibili in dev; in produzione l'overlay non esiste comunque.
// ---------------------------------------------------------------------------
window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason;
  if (isHandledApiError(reason) || reason?.isAxiosError) {
    // Errore API già notificato con toast italiano: non mostrare overlay.
    try { console.warn("[unhandledrejection:api-already-handled]", reason?.message); } catch {}
    event.preventDefault?.();
    return;
  }
  // Altri errori: lasciarli propagare (overlay in dev, log in prod).
  try { console.error("[unhandledrejection]", reason); } catch {}
});

// Health check periodico backend/DB.
startHealthCheck();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
